import { z } from "zod";
export const CardSchema = z.object({
    cardId: z.string().nullish(),
    last4: z.string().length(4).nullish(),
    expiryMonth: z.string().nullish(),
    expiryYear: z.string().nullish(),
    brand: z.string().nullish(),
    name: z.string().nullish(),
});
